import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import { useAuth } from '@/composables/useAuth'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import {
  useShokurekishoFormatData,
  toExampleDialogItems,
  type ShokurekishoExampleSentences
} from '@/composables/format-edit/useShokurekishoFormatData'
import { useShokurekishoAiSummary } from '@/composables/format-edit/useShokurekishoAiSummary'
import '@/assets/css/ai-streaming.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoJobSummaryCard',
  props: {
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  exampleSentences?: ShokurekishoExampleSentences
};



const formatData = useShokurekishoFormatData()
const { globalVar } = useHostServices()
const { isAuthenticated } = useAuth()
const exampleVisible = ref(false)

const inAppPayments = computed(
  () =>
    !!(globalVar as typeof globalVar & { in_app_payments?: boolean })
      .in_app_payments
)
const isYagiPrime = computed(() => !!globalVar.isYagiPrime)

const summaryExamples = computed(() =>
  toExampleDialogItems(
    props.exampleSentences?.summary,
    formatData.occupation || 'others'
  )
)

const {
  aiSummaryVisible,
  aiSummaryResultView,
  aiResultSummaryResult,
  aiUsageCount,
  aiMaxUsageCount,
  aiIsStreaming,
  aiIsThinking,
  aiThinkingLabel,
  aiReasoningText,
  aiShowReasoning,
  openAiSummaryDialog,
  closeAiSummaryDialog,
  getAISummary,
  goYagiprimeRegisterSummary,
  applySummaryResult,
  toggleAiReasoning,
  cancelAIStream
} = useShokurekishoAiSummary(formatData)

function onSelectExample(item: { description: string }) {
  formatData.jobSummary = item.description.replace(/<br>/gi, '\n')
}

function onSummaryVisible(value: boolean) {
  aiSummaryVisible.value = value
  if (!value) cancelAIStream()
}

return { __sfc: true,props, formatData, globalVar, isAuthenticated, exampleVisible, inAppPayments, isYagiPrime, summaryExamples, aiSummaryVisible, aiSummaryResultView, aiResultSummaryResult, aiUsageCount, aiMaxUsageCount, aiIsStreaming, aiIsThinking, aiThinkingLabel, aiReasoningText, aiShowReasoning, openAiSummaryDialog, closeAiSummaryDialog, getAISummary, goYagiprimeRegisterSummary, applySummaryResult, toggleAiReasoning, cancelAIStream, onSelectExample, onSummaryVisible, NewRirekishoExampleSentenceDialog, AiMyprDialog }
}

})